import PlanFeaturesItem from './plan-features-item';

import { PlanFeature as PlanFeatureType, PlanOffering } from '../plan.types';
import { PlanFeaturesContainer, PlanFeaturesFooter, PlanFeaturesHeader } from './plan-features.styles';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useTheme } from 'shared/styles/theme';

type PlanFeaturesProps = {
  features: PlanFeatureType[];
  offerings: PlanOffering[];
};

export default function PlanFeatures({ features, offerings }: PlanFeaturesProps) {
  const router = useRouter();
  const { theme } = useTheme();

  const handleOnClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, href: string) => {
    e.preventDefault();
    if (href !== '') {
      href.includes('http') ? window.open(href, '_blank') : router.push(href);
    }
  }

  const renderOfferingName = (name: string) => {
    if (name.endsWith('+')) {
      const baseName = name.slice(0, -1);
      return (
        <>
          {baseName}
          <sup>+</sup>
        </>
      );
    }
    return name;
  };

  return (
    <PlanFeaturesContainer>
      {/* Features header */}
      <PlanFeaturesHeader className={`offerings-${offerings.length}`}>
        <h2 className="features">Features</h2>
        {offerings.map((offering) =>
          !!offering.icon ? (
            <div className={`offering ${offering.class}`} key={offering.id}>
              {/* eslint-disable-next-line */}
              <img src={`${offering.icon}_${theme}.svg`} />
            </div>
          ) : (
            <div className="offering" key={offering.id}>
              {renderOfferingName(offering.name)}
            </div>
          ),
        )}
      </PlanFeaturesHeader>
      {/* Features */}
      {features.map((f) => (
        <PlanFeaturesItem feature={f} offerings={offerings} key={f.id} />
      ))}
      {/* Features footer */}
      <PlanFeaturesFooter className={`offerings-${offerings.length}`}>
        {offerings.map((offering) => (
          <div className={'offering-button ' + offering?.class} key={`${offering.id}-link`}>
            <Link className={offering.link?.href === '' ? 'disabled' : ''} href="" onClick={(e) => handleOnClick(e, offering.link?.href || '')}>{offering.link?.text}</Link>
          </div>
        ))}
      </PlanFeaturesFooter>
    </PlanFeaturesContainer>
  );
}
